import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentVideo from '../../../models/BlockComponentValues/BlockComponentVideo';

class BlockVideoData {
  title: BlockComponentText;
  video: BlockComponentVideo;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockVideoData {
  export function make(title: BlockComponentText, video?: BlockComponentVideo): BlockVideoData {
    return {
      title,
      video,
    };
  }

  export function getDefault(): BlockVideoData {
    return {
      title: BlockComponentText.getDefault(),
      video: BlockComponentVideo.getDefault(),
    };
  }
}

export default BlockVideoData;
